<app-modal
  [title]="'Online-Bestellung' | trans:'online-orders/details-modal/header/title'"
  [textAfterTitle]="details()?.bookingCode"
  [compact]="false"
  maxWidth="1600px"
>
  <ng-template>
    @if (isLoading()) {
      <div class="d-flex justify-content-center full-height align-items-center">
        <app-loader size="lg" />
      </div>
    } @else {
      @if (details(); as order) {
        <div class="d-flex gap-24 m-t-16">
          <div class="flex-grow-1 w-0">
            <table class="full-width overview">
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Kunde' | trans:'online-orders/details-modal/overview/labels.Customer'), value: order.customerName || order.address }"
              />
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('E-Mail' | trans:'online-orders/details-modal/overview/labels.Email'), value: order.email }"
              />
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Lieferadresse' | trans:'online-orders/details-modal/overview/labels.DeliveryAddress'), value: order.deliveryAddress }"
              />

              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Status' | trans:'online-orders/details-modal/overview/labels.Status'), value: (statusLabels[order.status] | trans:'online-orders/details-modal/status/' + order.status), withTopSeparator: true }"
              />
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Kauf' | trans:'online-orders/details-modal/overview/labels.PurchaseDate'), value: (order.purchaseDate | localeDatetimeFormat) }"
              />
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Kino' | trans:'online-orders/details-modal/overview/labels.Cinema'), value: order.cinemaName }"
              />
              <ng-container
                [ngTemplateOutlet]="overviewTableRow"
                [ngTemplateOutletContext]="{ label: ('Betrag' | trans:'online-orders/details-modal/overview/labels.Amount'), value: ((order.amount | numberToCurrency) + ' ' + languageConfig.currency.short) }"
              />

              @for (p of order.positions; track p.payVoucherId; let i = $index; let first = $first) {
                <ng-container
                  [ngTemplateOutlet]="overviewTableRow"
                  [ngTemplateOutletContext]="{
                    label: ('Position [[n]]' | trans:'online-orders/details-modal/overview/labels.Position':[['n', i + 1]]),
                    value: positionTextsByPayVoucherId().get(p.payVoucherId),
                    withTopSeparator: first
                  }"
                />
              }
            </table>
          </div>

          <div class="left-separator p-l-24 flex-grow-1 w-0">
            <div class="d-flex flex-direction-column gap-24">
              <div>
                <p class="t2 c-t-gray-500 fw-medium text-uppercase">
                  {{ 'Ausgabe' | trans:'online-orders/details-modal/action-buttons/groups/issue.Label' }}
                </p>

                <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
                  <button
                    class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                    [disabled]="!canFulfil()"
                    (click)="startFulfilment()"
                  >
                    <i class="ri-hand-coin-line"></i>
                    {{ 'Ausgeben' | trans:'online-orders/details-modal/action-buttons/issue.Button' }}
                  </button>

                  @if (hasUnsupportedPositions()) {
                    <p class="p2 c-t-gray-500">
                      {{ 'Diese Bestellung enthält Positionen, die nur in der Kasse Win ausgegeben werden können.' | trans:'online-orders/details-modal/unsupported-positions.Text' }}
                    </p>
                  }
                </div>
              </div>

              <div>
                <p class="t2 c-t-gray-500 fw-medium text-uppercase">
                  {{ 'Dokumente' | trans:'online-orders/details-modal/action-buttons/groups/documents.Label' }}
                </p>

                <div class="m-t-8 d-flex flex-direction-column gap-12 align-items-start">
                  <button
                    class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
                    [disabled]="!canOpenDeliveryNote() || isReportGenerating()"
                    (click)="openDeliveryNote()"
                  >
                    <i class="ri-file-list-3-line"></i>
                    {{ 'Lieferschein' | trans:'online-orders/details-modal/action-buttons/delivery-note.Button' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary text-uppercase"
        (click)="close()"
      >
        {{ 'Abbrechen' | trans:'online-orders/details-modal/cancel.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<ng-template
  #overviewTableRow
  let-label="label"
  let-value="value"
  let-withTopSeparator="withTopSeparator"
>
  <tr [class.top-separator]="withTopSeparator">
    <td width="300px">
      <div class="p1 c-t-blue-700">
        {{ label }}
      </div>
    </td>
    <td>
      <div class="p2">
        {{ value | empty }}
      </div>
    </td>
  </tr>
</ng-template>

<app-online-order-code-input-modal
  #onlineOrderCodeInputModalComponent
  (codeSubmitted)="fulfilPosition($event.position, $event.code)"
/>

<app-pdf-viewer-modal #pdfViewerModalComponent />
